<section class="tab-wrapper" *ngIf="mitteilung">
    <div class="alert alert-success" role="note">
        <p class="header-5" id="mg_gesendetHinweisTitle_txt">
            Ihre Veränderungsmitteilung wurde an die Familienkasse gesendet.
        </p>
        <span id="mg_gesendetHinweisText_txt"
            >Bitte laden Sie sich die Veränderungsmitteilung für Ihre Unterlagen herunter.</span
        >
    </div>

    <h2 class="mitteilung-header" id="mitteilung_header_txt">Ihre übermittelten Daten</h2>

    <div id="mg_falldatenHeader_txt" class="padding-top-20"><strong>Falldaten</strong></div>

    <div class="row padding-top-20">
        <div [ngSwitch]="mitteilung.veraenderungsart" id="mg_veraenderungsart_txt">
            Veränderungsart:
            <span *ngSwitchCase="'EINTRITT'">Eintritt</span>
            <span *ngSwitchCase="'AUSTRITT'">Austritt</span>
            <span *ngSwitchCase="'KINDERPLUS'">Zu berücksichtigende Kinder hinzufügen</span>
            <span *ngSwitchCase="'KINDERMINUS'">Zu berücksichtigende Kinder entfernen</span>
            <span *ngSwitchCase="'ORDNUNGSKRITERIUM'">Ordnungskriterium ändern</span>
        </div>

        <div [ngSwitch]="mitteilung.veraenderungsart" id="mg_veraenderungsdatum_txt">
            <span *ngSwitchCase="'EINTRITT'">Eintrittsdatum</span>
            <span *ngSwitchCase="'AUSTRITT'">Austrittsdatum</span>
            <span *ngSwitchDefault>Änderung gültig ab</span>:
            {{ mitteilung.veraenderungsdatum | date: 'dd.MM.yyyy' }}
        </div>
    </div>

    <div id="mg_BeschaeftigtenHeader_txt" class="padding-top-20"><strong>Daten der/ des Beschäftigten</strong></div>

    <div class="row padding-top-20">
        <div id="mg_mitarbeiterNachname_txt">Nachname: {{ mitteilung.mitarbeiterNachname }}</div>

        <div id="mg_mitarbeiterVorname_txt">Vorname: {{ mitteilung.mitarbeiterVorname }}</div>

        <div id="mg_mitarbeiterGeburtsdatum_txt">
            Geburtsdatum: {{ mitteilung.mitarbeiterGeburtsdatum | date: 'dd.MM.yyyy' }}
        </div>
    </div>

    <div class="row padding-top-20">
        <div id="mg_kindergeldnummer_txt" *ngIf="mitteilung.kindergeldnummer">
            Kindergeldnummer: {{ mitteilung.kindergeldnummer }}
        </div>

        <div *ngIf="mitteilung.veraenderungsart !== 'ORDNUNGSKRITERIUM'" id="mg_ordnungskriterium_txt">
            Ordnungskriterium des Arbeitgebers: {{ mitteilung.ordnungkriterium }}
        </div>
    </div>

    <div
        *ngIf="mitteilung.veraenderungsart === 'ORDNUNGSKRITERIUM'"
        id="mg_ordnungskriteriumHeader_txt"
        class="padding-top-20"
    >
        <strong>Ordnungskriterium</strong>
    </div>

    <div class="row padding-top-20" *ngIf="mitteilung.veraenderungsart === 'ORDNUNGSKRITERIUM'">
        <div id="mg_ordnungskriterium_alt_txt">Bisheriges Ordnungskriterium: {{ mitteilung.ordnungkriterium }}</div>
        <div id="mg_ordnungskriterium_neu_txt">Künftiges Ordnungskriterium: {{ mitteilung.ordnungkriteriumNew }}</div>
    </div>

    <div *ngIf="mitteilung.veraenderungsart !== 'ORDNUNGSKRITERIUM'" id="mg_kinderHeader_txt" class="padding-top-20">
        <strong>Kind(er)</strong>
    </div>

    <div *ngFor="let kind of kinderMitteilung; let i = index">
        <div class="row padding-top-20">
            <div id="mg_kindVorname_{{ i }}_txt">Vorname: {{ kind.kindVorname }}</div>

            <div id="mg_kindAbweichenderNachname_{{ i }}_txt" *ngIf="kind.kindAbweichenderNachname">
                Abweichender Nachname: {{ kind.kindAbweichenderNachname }}
            </div>

            <div id="mg_kindGeburtsdatum_{{ i }}_txt">
                Geburtsdatum: {{ kind.kindGeburtsdatum | date: 'dd.MM.yyyy' }}
            </div>
        </div>
    </div>

    <ng-container *ngIf="mitteilung.veraenderungNachricht">
        <div id="mg_veraenderungNachrichtHeader_txt" class="padding-top-20"><strong>Ihre Anmerkungen:</strong></div>
        <div class="row padding-top-20">
            <div id="mg_veraenderungNachricht_txt" class="text-break">
                {{ mitteilung.veraenderungNachricht }}
            </div>
        </div>
    </ng-container>

    <div class="row ba-form-button-row">
        <div class="col-sm-12 col-md-6 text-left">
            <px-button buttonStyleType="secondary" id="eae_neueAnfrage" (buttonClicked)="neueAnfrage.emit()"
                >Neue Anfrage</px-button
            >
        </div>
        <div class="col-sm-12 col-md-6 text-right" *ngIf="getUrl() as url">
            <a
                class="ba-btn ba-btn-primary px-button"
                id="eae_downloadFile_btn"
                [href]="url"
                (click)="downloadFile()"
                pxMatomoEventOnClick="runterladen"
                pxMatomoEventName="Veränderungsmitteilung herunterladen"
                [attr.download]="filename"
                target="_blank"
                >Als PDF Downloaden</a
            >
        </div>
    </div>
</section>
